import React, {useEffect} from "react";
import './App.css';
import {BrowserRouter as Router, Switch} from "react-router-dom";
import {PublicRoute} from "./PublicRoute";
import {PrivateRoute} from "./PrivateRoute";
import DashboardPelayanan from "./screen/dashboard";
import Landing from "./screen/landing";
import Approval from "./screen/approval";
import Broadcast from "./screen/broadcast";
import {AuthContext, DataContext} from "./Context";

function App() {
    // AUTH-CONTROLLER
    const initialLoginState = {
        isLoading: true,
        userName: null,
        userToken: null,
        userType: 'pelayanan',
    };

    const checkToken = async (token) => {
        const requestBody = new URLSearchParams();
        requestBody.append('token', token);

        fetch("CHECK_TOKEN", {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'x-api-key': "API_KEY",
            },
            body: requestBody.toString(),
        }).then((response) => {
            if (response.status === 200) {
                return true;
            } else {
                return false;
            }
        }).catch((error) => {
            console.log(error);
            return false;
        });

    };

    const loginReducer = (prevState, action) => {
        switch (action.type) {
            case 'RETRIEVE_TOKEN':
                return {
                    ...prevState,
                    userName: action.id,
                    userToken: action.token,
                    isLoading: false,
                };
            case 'LOGIN':
                return {
                    ...prevState,
                    userName: action.id,
                    userToken: action.token,
                    isLoading: false,
                };
            case 'LOGOUT':
                return {
                    ...prevState,
                    userName: null,
                    userToken: null,
                    isLoading: false,
                };
        }
    };

    const [loginState, dispatch] = React.useReducer(loginReducer, initialLoginState);

    const authContext = React.useMemo(() => ({
        signIn: async (username, usertoken) => {
            // let userSession = {userName: username, userToken: usertoken};
            // let userSession64 = base64.encode(JSON.stringify(userSession));
            try {
                // await localStorage.setItem('logger', userSession64);
                await localStorage.setItem('userName', username);
                await localStorage.setItem('userToken', usertoken);
            } catch (e) {
                console.log(e);
            }
            dispatch({type: 'LOGIN', id: username, token: usertoken});
        },
        signOut: async () => {
            try {
                await localStorage.removeItem('logger');
                await localStorage.removeItem('userName');
                await localStorage.removeItem('userToken');
            } catch (e) {
                console.log(e);
            }
            dispatch({type: 'LOGOUT'});
        },
    }), []);

    useEffect(() => {
        setTimeout(async () => {
            let userToken;
            let userName;
            let logger;

            userToken = null;
            userName = null;
            logger = null;
            try {
                userToken = await localStorage.getItem('userToken');
                userName = await localStorage.getItem('userName');
            } catch (e) {
                console.log(e);
            }
            dispatch({type: 'RETRIEVE_TOKEN', token: userToken, id: userName});
            // let loggerJSON = JSON.parse(logger);
            // if (await checkToken(loggerJSON.usertoken)) {
            //     dispatch({type: 'RETRIEVE_TOKEN', token: loggerJSON.usertoken, id: loggerJSON.username});
            // }
        }, 1000);
    }, []);


    //DATA-CONTROLLER
    const initialData = {
        customerDataChart: [],
        customerData: [],
        totalCardCounter: [],
        dataPengajuanCustomer: [],
        statusCategory:[]
    };

    const dataReducer = (prevState, action) => {
        switch (action.type) {
            case 'SET_CUSTOMER_DATA_CHART':
                return {
                    ...prevState,
                    customerDataChart: action.data,
                };
            case 'SET_CUSTOMER_DETAIL_DATA':
                return {
                    ...prevState,
                    customerData: action.data,
                };
            case 'SET_STATUS_CATEGORY':
                return {
                    ...prevState,
                    statusCategory: action.data,
                };
            case 'SET_TOTAL_CARD_COUNTER':
                return {
                    ...prevState,
                    totalCardCounter: action.data,
                };
            case 'SET_DATA_PENGAJUAN_CUSTOMER':
                return {
                    ...prevState,
                    dataPengajuanCustomer: action.data,
                };
            case 'CLEAR_DATA':
                return {
                    customerDataChart: [],
                    customerData: [],
                    totalCardCounter: []
                }
        }
    };

    const [dataState, act] = React.useReducer(dataReducer, initialData);

    const dataContext = React.useMemo(() => ({
        setCustomerData: async (customerData) => {
            act({type: 'SET_CUSTOMER_DATA_CHART', data: customerData});
        },
        setCustomerDataTable: async (customerDetail) => {
            act({type: 'SET_CUSTOMER_DETAIL_DATA', data: customerDetail});
        },
        setTotalCardCounter: (cardData) => {
            act({type: 'SET_TOTAL_CARD_COUNTER', data: cardData});
        },
        setStatusCategory: (category) => {
            act({type: 'SET_STATUS_CATEGORY', data: category});
        },
        setDataPengajuanCustomer: async (customerData) => {
            act({type: 'SET_DATA_PENGAJUAN_CUSTOMER', data: customerData});
        },
        clearData: () => {
            act({type: 'CLEAR_DATA'});
        },
    }), []);


    return (
        <Router basename={'/admin'}>
            <div>
                <Switch>
                    <AuthContext.Provider value={[authContext, loginState]}>
                        <DataContext.Provider value={[dataContext, dataState]}>
                            <PublicRoute restricted={true} component={Landing} path="/" exact/>
                            <PrivateRoute component={DashboardPelayanan} path="/dashboard" exact/>
                            <PrivateRoute component={Approval} path="/approval" exact/>
                            <PrivateRoute component={Broadcast} path="/broadcast" exact/>
                        </DataContext.Provider>
                    </AuthContext.Provider>
                </Switch>
            </div>
        </Router>
    );
}

export default App;
